import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { staticurl } from '../common/constants'
import { useStore } from '../context/StoreContext'
import {useUser} from '@clerk/clerk-react';

export default function ItemCard({ img, display }) { 
    const { isLoaded, isSignedIn, user } = useUser();
    const {isAdmin} = useStore();
    const {selectProductForEdit} = useStore();
    const handleEditBtnClick = () => {
      selectProductForEdit(img)
    }
  return (
    <Link to={`/product/${img._id}`} className="text-decoration-none" style={{ display }}>
      <div className="card h-100 border-0 shadow-sm overflow-hidden">
        <img 
          src={staticurl + img.prod_thumbnail} 
          className="card-img-top" 
          alt={img.prod_name} 
          style={{ height: '200px', objectFit: 'cover' }}
        />
        <hr className='m-0 p-0' />
        {(isAdmin || (isLoaded && isSignedIn && ['superadmin','admin'].includes(user?.publicMetadata?.role))) && (
            <div className="position-absolute top-0 end-0 p-2">
                <button onClick={handleEditBtnClick} className="btn btn-sm btn-light rounded-circle shadow-sm" data-bs-toggle="modal" data-bs-target="#editProductDetailModel">
                    <i className="fa-solid fa-pen-to-square text-dark"></i>
                </button>
            </div>
        )}
        <div className="card-body d-flex flex-column align-items-start p-3">
          <h6 className="card-title mb-2 text-dark text-left fw-bold">
            {img.prod_name}
          </h6>
          <div className="d-flex justify-content-between w-100 align-items-center mt-auto">
            <div className="text-dark fw-bold" style={{ display: 'none' }}>
              {img.discounted_price ? (
                <>
                  <div className="fs-5">Rs. {img.discounted_price}</div>
                  <small className="text-muted text-decoration-line-through fw-normal">Rs. {img.price ?? 0}</small>
                </>
              ) : (
                <span className="fs-5">Rs. {img.price ?? 0}</span>
              )}
            </div>
            <span className={`badge ${img.stock > 0 ? 'bg-success' : 'bg-danger'}`}>
              {img.stock > 0 ? 'In Stock' : 'Out of Stock'}
            </span>
          </div>
        </div>
      </div>
    </Link>
  )
}
